import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-work-flow-popup',
  templateUrl: './order-work-flow-popup.component.html',
  styleUrls: ['./order-work-flow-popup.component.css']
})
export class OrderWorkFlowPopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
